import {PlayerColor} from '@colonist/game-states'
import {ImageURL} from '@colonist/types'
import KnightMoveRed from '@static/images/knight_move_red.svg'
import KnightMoveBlue from '@static/images/knight_move_blue.svg'
import KnightMoveOrange from '@static/images/knight_move_orange.svg'
import KnightMoveGreen from '@static/images/knight_move_green.svg'
import KnightMoveBlack from '@static/images/knight_move_black.svg'
import KnightMoveBronze from '@static/images/knight_move_bronze.svg'
import KnightMoveSilver from '@static/images/knight_move_silver.svg'
import KnightMoveGold from '@static/images/knight_move_gold.svg'
import KnightMoveWhite from '@static/images/knight_move_white.svg'
import KnightMovePurple from '@static/images/knight_move_purple.svg'
import KnightMoveMysticBlue from '@static/images/knight_move_mysticblue.svg'
import KnightMovePink from '@static/images/knight_move_pink.svg'

export const KNIGHT_MOVE_IMAGE_PATH: Record<PlayerColor, ImageURL> = {
    [PlayerColor.None]: '' as ImageURL,
    [PlayerColor.Red]: KnightMoveRed,
    [PlayerColor.Blue]: KnightMoveBlue,
    [PlayerColor.Orange]: KnightMoveOrange,
    [PlayerColor.Green]: KnightMoveGreen,
    [PlayerColor.Black]: KnightMoveBlack,
    [PlayerColor.Bronze]: KnightMoveBronze,
    [PlayerColor.Silver]: KnightMoveSilver,
    [PlayerColor.Gold]: KnightMoveGold,
    [PlayerColor.White]: KnightMoveWhite,
    [PlayerColor.Purple]: KnightMovePurple,
    [PlayerColor.MysticBlue]: KnightMoveMysticBlue,
    [PlayerColor.Pink]: KnightMovePink,
}
